module.exports = "/_next/static/images/5c6aef3e4ac0d7f244042f18562e8e42-requirements-lg.jpg.webp";